import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import AgregarCategoriaModelo from "views/Modulos/Administracion/Modelos/AgregarCategoriaModelo.jsx";
import Globales from "utils/Globales";
import { Edit, Close, AddCircle, Search, Clear, Filter9Plus } from "@material-ui/icons";
import ReactLoading from "react-loading";

class CategoriaModelo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      NombreCategoriaModelo: '',
      CategoriaPadre: '',
      idCategoriaPadre: null,
      Descripcion: '',
      Titulo: '',
      categoriasModelos3D: [],
      mensaje: '',
      br: false,
      colorNotificacion: 'success',
      errorNombre: false,
      errorCategoriaPadre: false,
      errorDescripcion: false,
      categoriasModelos3DMostrar: [],
      entroFiltrar: false,
      notificacion: false
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.Fin = 10;
    global.entrar = true;
    global.response = null;
    this.eventoModalEliminar = this.eventoModalEliminar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.eliminarCategoriaModelo = this.eliminarCategoriaModelo.bind(this);
    this.filtrarCategoriaModelo = this.filtrarCategoriaModelo.bind(this);
    this.seleccionado = {};
  }

  componentDidMount() {
    this.obtenerCategoriasModelos();
    this.obtenerAllCategoriasModelos();

  }

  //Obtener todos los registros guardados
  obtenerAllCategoriasModelos() {
    fetch(Globales.Url + 'Modelos/Categoria/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          this.setState({ categoriasModelos3D: [] });
        } else { //Obtuvo los registros correctamente
          this.setState({ categoriasModelos3D: data.data });
        }
      });
  }

  //Obtener el total de registros que se indican
  obtenerCategoriasModelos() {
    fetch(Globales.Url + 'Modelos/Categoria/ListadoCategoriaModelo', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ Fin: global.Fin })
    }
    ).then(res => {
      global.response = res.status;
      res.json()
        .then(data => {
          if (data.error) { //Error al obtener los registros
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje,categoriasModelos3DMostrar:[] });
            this.showNotification();
          } else { //Obtuvo los registros correctamente
            if(data.data.length > 0){
              this.setState({ categoriasModelos3DMostrar: data.data });
            }else{
              this.setState({ categoriasModelos3DMostrar: [] });
            }
          }
        })
        .catch(err => console.error(err));
    });
  }

  //Obteniendo el nombre de las categorías padres
  obtenerNombreCategoriaPadre(idCategoria) {  

    //Variable vacia
    var NombreCategoriaPadre = '';
    // Recorriendo registros para obtener el nombre de la categoría
    //console.log(this.state.categoriasModelos3D)
    this.state.categoriasModelos3D.map(categorias => {
      
      if (idCategoria.toString() == categorias._id.toString()) {
        if(categorias.idCategoriaPadre == null){
          NombreCategoriaPadre = categorias.NombreCategoriaModelo;
        }else{
            NombreCategoriaPadre = this.obtenerNombreCategoriaPadre(categorias.idCategoriaPadre) + " - " + categorias.NombreCategoriaModelo
        }
      } else if (idCategoria == 'Sin Categoría') {
        NombreCategoriaPadre = "Sin Categoría";
      }
    });
    //Regresando el nombre de la categoría
    return NombreCategoriaPadre;
  }

  //Función de editar registro
  editarCategoriaModelo(id, Nombre, CategoriaPadre, Descripcion) {
    this.setState({ _id: id, NombreCategoriaModelo: Nombre, idCategoriaPadre: CategoriaPadre, Descripcion: Descripcion, op: 1, showAgregar: true, Titulo: "Editar Categoría Padre" });
  }

  //Función de eliminar registro
  eliminarCategoriaModelo(id) {
    fetch(Globales.Url + 'Modelos/Categoria/BajaCategoriaModelo', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ _id: id })
    }
    ).then(res => res.json())
      .then(data => {
        if (data.error) {//Error al obtener los registros
          this.setState({ colorNotificacion: 'danger' });
        } else {//Obtuvo los registros correctamente
          this.setState({ colorNotificacion: 'success' });
        }
        this.setState({ mensaje: data.mensaje, show: false });
        this.showNotification("tr");
        this.obtenerCategoriasModelos(); 
        this.obtenerAllCategoriasModelos();
        this.limpiar();
      });
  }

  //Función para el evento de eliminar
  deleteEvent = (values) => {
    this.seleccionado = values;
    this.setState({ show: true });
  }

  //Función para habilitar el modal de eliminar
  eventoModalEliminar(e) {
    if (!e) {
      this.setState({ show: false });
      return;
    }
    //Eliminar el elemento
    this.eliminarCategoriaModelo(this.seleccionado);
  }

  //Función para abrir el modal de agregar registro
  openModalAgregarCategoriaModelo = () => {
    this.setState({ showAgregar: true, Titulo: "Nueva categoría de Modelo 3D", op: 0 });
  }

  //Función que recupera valores para el modal de agregar
  eventoModalCategoriaModelo = (mensaje, colorNotificacion) => {
    //Cambiar valores por default
    this.setState({ showAgregar: false, Titulo: "Nueva categoría de Modelo 3D", NombreCategoriaModelo: "", op: 0 })
    this.obtenerCategoriasModelos();
    this.obtenerAllCategoriasModelos();
    this.limpiar();
    //Validar que el mensaje venga diferente de vacio
    if (mensaje !== 'esc') {
      this.setState({ mensaje: mensaje, colorNotificacion: colorNotificacion })
      this.showNotification();
    }
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  //Función para realizar el filtrado de búsqueda
  filtrarCategoriaModelo() {
    var valor1 = 0;
    //Validar que el input no este vacio
    if (this.state.NombreCategoriaModelo.trim() === '') {
      this.setState({ errorNombre: true, colorNotificacion: 'danger', mensaje: "Complete el campo de búsqueda", NombreCategoriaModelo: '' });
      valor1 = 1;
    } else {
      this.setState({ errorNombre: false });
      valor1 = 0;
    }
    //Validar si hay campos requeridos
    if (valor1 === 0) { //No hay campos requeridos
      fetch(Globales.Url + 'Modelos/Categoria/FiltrarCategoriaModelo', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }
        , body: JSON.stringify(this.state)
      }
      ).then(res => res.json())
        .then(data => {
          if (data.error) { //Error en la respuesta
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else if (data.data.length === 0) { //Ninguna coincidencia
            this.setState({ colorNotificacion: "warning", ategoriasModelos3DMostrar:[],mensaje: "No hay ninguna coincidencia", entroFiltrar: true })
            this.showNotification();
          } else { //Filtrado exitoso
            this.setState({ colorNotificacion: 'success', categoriasModelos3DMostrar: data.data, entroFiltrar: true })
          }
        })
        .catch(err => console.error(err));
    }
  }

  //Función para volver los valores por default
  limpiar() {
    this.setState({ NombreCategoriaModelo: '', entroFiltrar: false });
    global.Fin = 10;
    global.entrar = true;
    global.response = null;
    this.obtenerCategoriasModelos();
    this.obtenerAllCategoriasModelos();
  }

  //Función para mostrar mas registros en la tabla
  verMas() {
    //Validar si entro a filtrar
    if (this.state.entroFiltrar) {
      this.limpiar();
    } else {
      //Creando variable con mas valor que la variable global
      var num = global.Fin + 10;
      //Validación de el valor de la variable global sea menor o igual que el total de registros obtenidos
      if (num <= this.state.categoriasModelos3D.length && global.entrar) {
        //Cambiando el valor de la variable global
        global.Fin = num;
        //Obteniendo el número de registros requeridos
        this.obtenerCategoriasModelos();
      };
      //Validación de que el número total de registros requiridos sea mayor al total de registros y cambio de valor de variables
      if (num > this.state.categoriasModelos3D.length && global.entrar) {
        //Cambiando el valor de la variable para que no vuelva a traer mas registros
        global.entrar = false;
        //Cambiando el valor de la variable global
        global.Fin = this.state.categoriasModelos3D.length;
        //Obteniendo el total de los registros requeridos
        this.obtenerCategoriasModelos();
      };
      //Validación de que ya no hay mas registros que mostrar
      if (!global.entrar) {
        this.setState({ mensaje: 'No hay más categorías de modelos 3D para mostrar', colorNotificacion: 'warning' });
        this.showNotification();
      };
    }
  }

  render() {
    let agregar;
    if (this.state.showAgregar == true) {
      agregar =
        <AgregarCategoriaModelo
          Titulo={this.state.Titulo}
          NombreCategoriaModelo={this.state.NombreCategoriaModelo}
          idCategoriaPadre={this.state.idCategoriaPadre}
          Descripcion={this.state.Descripcion}
          categoriasModelos3D={this.state.categoriasModelos3D}
          _id={this.state._id}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalCategoriaModelo}
          op={this.state.op}
          classes={this.props}
        />
    }
    const { classes } = this.props;
    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text>
                <h4 className={classes.cardTitle}>Categoría Modelos 3D</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Buscar categoría"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        onChange: this.handleChange,
                        value: this.state.NombreCategoriaModelo,
                        name: "NombreCategoriaModelo",
                        id: "NombreCategoriaModelo",
                        type: "text",
                        error: this.state.errorNombre
                      }}
                      className="mt-5"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="info" round onClick={() => this.filtrarCategoriaModelo()}><Search />Buscar</Button>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="danger" round onClick={() => this.limpiar()}><Clear />Limpiar</Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="info" round onClick={() => this.verMas()}><Filter9Plus />Ver Más</Button>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="success" round onClick={() => this.openModalAgregarCategoriaModelo()}><AddCircle />Agregar</Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          {/* Tabla de categoriasModelos3D */}
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={7}>
                    <h4 className="pull-left">Lista de Categorías de Modelos 3D</h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                {global.response === 200 ?
                  <div className="table-wrapper-scroll-y">
                    <table className="col-xs-12 col-sm-12 col-md-12">
                      <thead>
                        <th className="center">Nombre</th>
                        <th className="center">Categoría</th>
                        <th className="pull-right">Acciones</th>
                      </thead>
                      <tbody>
                        {this.state.categoriasModelos3DMostrar.map(CategoriasModelos3D => {
                          return (
                            <tr key={CategoriasModelos3D._id}>
                              <td>{CategoriasModelos3D.NombreCategoriaModelo}</td>
                              <td>{(CategoriasModelos3D.idCategoriaPadre == null? "Sin categoría":this.obtenerNombreCategoriaPadre(CategoriasModelos3D.idCategoriaPadre))}</td>
                              <td className="pull-right">
                                <Button color="warning" round justIcon size="sm" onClick={() => this.editarCategoriaModelo(CategoriasModelos3D._id, CategoriasModelos3D.NombreCategoriaModelo, CategoriasModelos3D.idCategoriaPadre, CategoriasModelos3D.Descripcion)}><Edit /></Button>
                                <Button color="danger" round justIcon size="sm" onClick={() => this.deleteEvent(CategoriasModelos3D._id)}><Close /></Button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div> :
                  <GridContainer justify='center'>
                    <ReactLoading type={'bubbles'} color={'#CFCFCF'} height={'10%'} width={'10%'} />
                  </GridContainer>
                }
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar Categoría de Modelos 3D"}
            Cuerpo={"¿Está seguro que desea eliminar la categoría de Modelos 3D?"}
            show={this.state.show}
            eventClick={this.eventoModalEliminar}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    )
  }
}

export default withStyles(headerLinksStyle)(CategoriaModelo);